// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/home-new.less
// module id = 3222
// module chunks = 0